import script from "./PdfImageViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./PdfImageViewer.vue?vue&type=script&setup=true&lang=js"

import "./PdfImageViewer.vue?vue&type=style&index=0&id=231fc0db&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-231fc0db"]])

export default __exports__